module.exports = __webpack_public_path__ + "static/media/chocolate-chunk-blondie.52bba586.png";